import { CaretsExpandVertical } from '@gravity-ui/icons';
import { Button, Icon, Pagination, PaginationProps, Select } from '@gravity-ui/uikit';
import { MRT_SortingState } from 'material-react-table';
import { useState } from 'react';

import styles from './styles.module.scss';
import { AdminEstablishmentsListBlock } from './admin-establishments-list-block';
import { EstablishmentFilterSheet } from '../sheets/establishment-filter-sheet';

interface EstablishmentProps {
	data: Establishment[];
	onAdd: () => void;
	pageSize: number;
	setPageSize: React.Dispatch<React.SetStateAction<number>>;
	pageIndex: number;
	setPageIndex: React.Dispatch<React.SetStateAction<number>>;
	totalItems: number | undefined;
	sorting: MRT_SortingState;
	setSorting: React.Dispatch<React.SetStateAction<MRT_SortingState>>;
	isMobile: any;
}

interface Establishment {
	id?: number;
	name: string;
}

export const AdminEstablishmentsList = ({
	data,
	onAdd,
	pageSize,
	setPageSize,
	pageIndex,
	setPageIndex,
	totalItems,
	sorting,
	setSorting,
	isMobile,
}: EstablishmentProps) => {
	const [selectedValues, setSelectedValues] = useState<string[]>(['От А-Я']);
	const [visibleFilter, setVisibleFilter] = useState(false);

	const handleSortChange = (value: string) => {
		switch (value) {
			case 'От А-Я':
				{
					setSorting([{ id: 'name', desc: false }]);
				}

				break;
			case 'От Я-А':
				{
					setSorting([{ id: 'name', desc: true }]);
				}
				break;

			default:
				setSorting([{ id: 'name', desc: true }]);
				break;
		}
	};

	const handlePaginationUpdate: PaginationProps['onUpdate'] = (newPage, newPageSize) => {
		setPageIndex(newPage - 1);
		setPageSize(newPageSize);
	};

	const onUpdate = (values: string[]) => {
		setSelectedValues(values);

		if (values.length > 0) {
			handleSortChange(values[0]);
		}
	};
	const label = selectedValues && selectedValues.length > 0 ? selectedValues[0] : 'Не выбрано';

	return (
		<div className={styles.list_container}>
			<div>
				{isMobile ? (
					<>
						<Button view="flat" onClick={() => setVisibleFilter(true)}>
							<Icon size={16} data={CaretsExpandVertical} />
							{label}
						</Button>
						<EstablishmentFilterSheet
							visibleFilter={visibleFilter}
							setVisibleFilter={setVisibleFilter}
							onSortChange={(value: any) => {
								handleSortChange(value);
								setSelectedValues([value]);
							}}
						/>
					</>
				) : (
					<Select
						value={selectedValues}
						onUpdate={onUpdate}
						filterable={true}
						renderControl={({ onClick, onKeyDown, ref }) => {
							return (
								<Button ref={ref} onClick={onClick} extraProps={{ onKeyDown }} view="flat">
									<Icon size={16} data={CaretsExpandVertical} />
									<span>{label}</span>
								</Button>
							);
						}}
					>
						<Select.Option value="От А-Я">От А-Я</Select.Option>
						<Select.Option value="От Я-А">От Я-А</Select.Option>
					</Select>
				)}
			</div>

			<div className={styles.list_container__blocks}>
				{data.map((establishment) => {
					return (
						<AdminEstablishmentsListBlock establishment={establishment} onAdd={onAdd} isMobile={isMobile} />
					);
				})}
			</div>

			<div className={styles.list_container__pagination}>
				{isMobile ? (
					<Pagination
						page={pageIndex + 1}
						pageSize={pageSize}
						total={totalItems}
						onUpdate={handlePaginationUpdate}
					/>
				) : (
					<Pagination
						page={pageIndex + 1}
						pageSize={pageSize}
						total={totalItems}
						pageSizeOptions={[10, 20, 40, 100]}
						onUpdate={handlePaginationUpdate}
					/>
				)}
			</div>
		</div>
	);
};
